export default {

    components: {},
    props: ['site'],
    data: () => {
        return {
            footerBackground: 'container-with-component-class-pink-bg',
            waitRouletteTiming: false,
            showAudioModalToggle: false,
            modalContent: '',
            activeAudioPlayer: null,
            activeAudio: null
        }
    },

    beforeMount() {

    },

    watch: {
        waitRouletteTiming: function (active) {
            let rouletteBlock = document.querySelector('.component-class-roulette .page-component__html-block');
            if (rouletteBlock === null) {
                return
            }

            if (active) {
                rouletteBlock.classList.add('waiting')
            } else {
                rouletteBlock.classList.remove('waiting')
            }
        }
    },

    mounted() {
        this.setupBackgroundStyles();
        this.setupIconsCheckAndTimes();
        this.setupAudioGameLinks();
        this.setupRouletteGame();
        this.setupFooterBackground();
    },
    methods: {
        setupFooterBackground: function (){
            let referencesElement = document.getElementsByClassName('component-class-references')[0];

            let hasBlueBg = Object.values(referencesElement.classList).indexOf('component-class-blue-bg') !== -1
            let hasBlueLightBg = Object.values(referencesElement.classList).indexOf('component-class-blue-light-bg') !== -1
            let hasPinkBg = Object.values(referencesElement.classList).indexOf('component-class-pink-bg') !== -1

            if (hasBlueBg) {
                this.footerBackground = 'container-with-component-class-blue-bg';
                return
            }

            if (hasBlueLightBg) {
                this.footerBackground = 'container-with-component-class-blue-light-bg';
                return
            }

            if (hasPinkBg) {
                this.footerBackground = 'container-with-component-class-pink-bg';
            }
        },
        setupIconsCheckAndTimes: function () {


            let iconCheck = document.getElementById('icon-check-rounded').innerHTML;
            let importIcons = document.getElementsByClassName('component-class-import-icon-check-rounded');

            Object.values(importIcons).forEach((el, index) => {
                el.querySelectorAll('svg').forEach((svgEl) => {
                    svgEl.parentNode.insertAdjacentHTML('beforeend', iconCheck);
                })
            });

            let iconX = document.getElementById('icon-x-rounded').innerHTML;
            let importIconsX = document.getElementsByClassName('component-class-import-icon-x-rounded');

            Object.values(importIconsX).forEach((el, index) => {
                el.querySelectorAll('svg').forEach((svgEl) => {
                    svgEl.parentNode.insertAdjacentHTML('beforeend', iconX);
                })
            });
        },
        setupBackgroundStyles: function () {
            let headerElementStyle = document.getElementById('header').getAttribute('style');
            let patternElements = document.querySelectorAll('.container-with-component-class-pattern');
            Object.values(patternElements).forEach((el, index) => {
                el.setAttribute('style', headerElementStyle);
            });

        },
        startRollRoulette: function (rouletteBlock) {

            this.waitRouletteTiming = true;
            let disc = rouletteBlock.querySelector('svg g#disc');

            let angle = Math.ceil(Math.random() * 1010) + 360;
            disc.style.transform = "rotate(" + angle + "deg)";

            setTimeout(() => {
                this.waitRouletteTiming = false;
                this.getRouletteResult(rouletteBlock, angle)
            }, 1000);
        },

        getRouletteResult: function (rouletteBlock,angle){

            let number = angle % 360;


            /*let result = 'roulette-';
            switch (number) {
                case number > 21 && number <= 110:
                    result += 'pink';
                    break;
                case number > 110 && number <= 190:
                    result += 'blue';
                    break;
                case number > 190 && number <= 270:
                    result += 'green';
                    break;
                case number > 293 && number <= 360 || number > 0 && number <= 21:
                    result += 'yellow';
                    break;

            }*/

            let winner = 'roulette-';
            if (number > 21 && number <= 110) {
                winner += 'pink';
            } else if (number > 110 && number <= 202) {
                winner += 'blue';
            } else if (number > 202 && number <= 290) {
                winner += 'green';
            } else if (number > 290 && number <= 360 || number > 0 && number <= 21) {
                winner += 'yellow';
            }

            console.log(winner)
            let audioComponent = document.querySelector(`.component-class-${winner}-audio .audio-player`);
            if (audioComponent === null) {
                console.warn('Winner audio not found');
                return
            }
            this.playAudio(audioComponent.getAttribute('rel'));
        },

        setupRouletteGame: function () {

            let rouletteSVG = document.getElementById('roulette-svg-icon');
            let roulette = document.createElement('div')
            roulette.id = 'roulette-game';
            roulette.innerHTML = rouletteSVG.innerHTML

            let rouletteBlock = document.querySelector('.component-class-roulette .page-component__html-block');
            if (rouletteBlock === null) {
                return
            }
            rouletteBlock.appendChild(roulette);

            let link = rouletteBlock.querySelector('.btn-holder');
            link.addEventListener('click', () => {
                this.startRollRoulette(rouletteBlock)
            });

        },

        toggleMenu: function () {
            document.getElementById('header').classList.toggle('open')
            document.getElementsByTagName('body')[0].classList.toggle('modal-open')
        },
        setupAudioGameLinks: function () {
            document.querySelectorAll('.container-with-component-class-sound-game .nav-link')
                .forEach((el) => {
                    el.setAttribute('rel', 'disabled')
                    el.addEventListener('click', (e) => {
                        let targetAudio = e.target.getAttribute('href');
                        let audioComponent = document.querySelector(`${targetAudio} .audio-player`);
                        this.showAudioModal(e, audioComponent, audioComponent !== null);
                        e.preventDefault();
                        return false;
                    })
                });

            this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
                if(modalId !== 'sound-game-modal') return
                document.getElementById('modal-audio-button').addEventListener('click', (e) => {
                    this.playAudio(this.activeAudioPlayer.getAttribute('rel'), e.target);
                })
            })
        },
        showAudioModal: function (e, audioComponent, withAudioButton){
            let modalContent = e.target.querySelector(`.description`).innerHTML;

            if(withAudioButton) {
            let audioSvgIcon = document.getElementById('audio-svg-icon').innerHTML
                modalContent += `<a id="modal-audio-button">${audioSvgIcon}</a>`
            }

            this.modalContent = modalContent;
            this.showAudioModalToggle = true;
            this.activeAudioPlayer = audioComponent
        },
        playAudio: function (audioURL, button) {

            if (this.activeAudio !== null && button !== undefined && (Object.values(button.classList).indexOf('playing') !== -1)) {
                this.stopAudio();
                button.classList.remove('playing');
                return
            }

            if (this.activeAudio !== null) {
                this.stopAudio();
            }

            this.activeAudio = new Audio(audioURL);
            this.activeAudio.loop = false;
            this.activeAudio.play();

            if(button === undefined) return;

            this.activeAudio.addEventListener('playing', (e) => {
                button.classList.add('playing');
            });
            this.activeAudio.addEventListener('ended', (e) => {
                button.classList.remove('playing');
            });
        },
        stopAudio: function () {
            this.activeAudio.pause();
            this.activeAudio = null;
        }

    }
}
